module.exports = __webpack_public_path__ + "static/media/milton_delgado.6e7a21de.jpg";